import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  closeActivityDetailModel,
  openActivityListModel,
} from "../../store/slices/modalSlice";
import { useEffect, useState } from "react";
import {
  Activities,
  ActivityDetail,
  getDataForDedActivityDetailPageApi,
} from "../../lib/api";
import {
  setActivityCategory,
  setActivityCode,
  setActivityGroup,
} from "../../store/slices/IdSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

const ActivityDetailModal = () => {
  const dispatch = useDispatch();
  const activityDetailModel = useSelector(
    (state: { modal: { activityDetailModel: boolean } }) =>
      state.modal.activityDetailModel
  );
  const dedActivityCode = useSelector((state: any) => state.ID.dedActivityCode);
  const [activity, setActivity] = useState<Activities | null>(null);
  const [loading, setLoading] = useState(false);
  const fetchActivityDetail = async () => {
    if (!activityDetailModel) return;
    setLoading(true);
    try {
      const data: ActivityDetail = await getDataForDedActivityDetailPageApi(
        dedActivityCode
      );
      setActivity(data.activity);
    } catch (err) {
      console.error("Failed to fetch activities:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!activityDetailModel) return;
    import("./DedActivityCss.css"); // lazy load CSS
    fetchActivityDetail();
  }, [activityDetailModel]);

  const handleCloseModal = () => {
    dispatch(setActivityCategory({ catId: 0, slug: "" }));
    dispatch(setActivityGroup(""));
    dispatch(setActivityCode(""));

    dispatch(closeActivityDetailModel());
  };
  const handleBackModal = () => {
    dispatch(closeActivityDetailModel());
    dispatch(openActivityListModel());
  };

  const handleGetActivityList = (activityGroup: string) => {
    dispatch(setActivityGroup(activityGroup));
    dispatch(setActivityCategory({ catId: 0, slug: "" }));
    dispatch(closeActivityDetailModel());
    dispatch(openActivityListModel());
  };

  return (
    <Modal
      show={activityDetailModel}
      onHide={handleCloseModal}
      scrollable
      centered
      backdrop="static"
      className="mb-fix slide-from-bottom activity-modal activity-list-modal"
    >
      {/* <Modal.Header closeButton></Modal.Header> */}
      <Modal.Body className="modal-dialog-scrollable pt-0">
        <div className="back-position border-bottom-1pt  py-3 ">
          <div className="btn-back-item" onClick={() => handleBackModal()}>
            <a href="javascript:void(0);">
              {" "}
              <FontAwesomeIcon icon={faChevronLeft} />{" "}
              <span className="d-sm-none d-md-block">Back</span>
            </a>
          </div>
          <h3 className="modal-title text-center text-uppercase font-20 ff-semibold m-0 w-100">
            Activity Detail
          </h3>
        </div>
        <div className="ded-activity-table-wrap mt-3">
          <div className="table-responsive mb-0">
            <table className="table mb-0 ded-activity-table">
              <thead>
                <tr>
                  <th className="desktop-width">Label</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <span className="font-15 ff-medium">Activity</span>
                  </td>
                  <td>{activity?.name}</td>
                </tr>
                <tr>
                  <td>
                    <span className="font-15 ff-medium">Activity Code</span>
                  </td>
                  <td>{activity?.activityCode}</td>
                </tr>
                <tr>
                  <td>
                    <span className="font-15 ff-medium">Activity Group</span>
                  </td>
                  <td>
                    <div className="d-flex align-items-center jutify-content-between">
                      {activity?.groupName}{" "}
                      <button
                        className="btn view-act-btn"
                        type="button"
                        onClick={() =>
                          handleGetActivityList(activity?.groupName || "")
                        }
                      >
                        View All
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span className="font-15 ff-medium">License Type</span>
                  </td>
                  <td>{activity?.licenseType}</td>
                </tr>
                <tr>
                  <td>
                    <span className="font-15 ff-medium">
                      Activity Description
                    </span>
                  </td>
                  <td>{activity?.description}</td>
                </tr>
                <tr>
                  <td>
                    <span className="font-15 ff-medium">Approval</span>
                  </td>
                  <td>{activity?.approval}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {loading && (
          <div className="text-center py-3">Loading activities...</div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ActivityDetailModal;
